<template>
  <div class="cm-html-preview">
    <div class="cm-html-preview__toolbar cm-toolbar">
      <div
        v-for="(item, index) in types"
        :key="index"
        class="cm-toolbar__item"
      >
        <b v-if="index !== 0">/</b>
        <button @click="openPreview(item)">
          <img
            :src="require(`@/assets/images/templates/${item}.svg`)"
            :alt="item"
          />
        </button>
      </div>
    </div>
    <modal
      v-if="activeType"
      :name="modalName"
      class="cm-html-preview__modal"
      width="100%"
      height="auto"
      :class="`preview--${activeType}`"
      :scrollable="true"
      :click-to-close="true"
      @opened="opened"
    >
      <Icon
        name="close"
        :class="`v--modal__close`"
        :width="24"
        :height="24"
        :scale="1"
        @click.native.prevent="$modal.hide(modalName)"
      >
        <Close />
      </Icon>
      <div class="preview-container">
        <iframe
          id="email-iframe"
          class="cm-html-preview__template"
          :srcdoc="preview"
          width="100%"
          height="100%"
        >
          <p>Your browser does not support iframes.</p>
        </iframe>
      </div>
    </modal>
  </div>
</template>

<script>
import { scaleHeight } from "@/utils/general";
import Icon from '@/manzana_library/components/Elements/Icon';
import Close from '@/manzana_library/components/Icons/Close';

export default {
  name: "CmHtmlPreview",
  components: {
    Icon,
    Close
  },
  props: {
    types: {
      type: Array,
      default: () => {
        return ["mobile", "tablet", "desktop"]
      }
    },
    preview: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      activeType: "",
      modalName: "cm-html-preview"
    }
  },
  methods: {
    opened() {
      scaleHeight(".cm-html-preview", ".v--modal-box", 90, 652);
    },
    openPreview(type) {
      this.activeType = type;
      this.$modal.show(this.modalName);
    }
  }
}
</script>

<style lang="scss" scoped>
.cm-html-preview {
  &__toolbar {
    align-items: flex-end;
    display: flex;
    width: 140px;
    b {
      font-weight: 400;
      padding: 0 15px;
    }
    button {
      background: none;
      padding: 0;
      margin: 0;
      transition: all 0.3ms ease;
      &:hover {
        opacity: 0.8;
      }
    }
  }
  .cm-toolbar {
    &__item {
      display: flex;
      align-items: center;
    }
  }
  .modal-header__icon {
    position: absolute;
    top: 7px;
    left: 5px;
  }
}
</style>

<style lang="scss">
@mixin previewTemplate($width, $height, $border, $borderTop: $border) {
  .v--modal-box {
    width: $width + 45px !important;
    .preview-container {
      border: $border solid #000;
      border-top-width: $borderTop;
      border-bottom-width: $borderTop;
      height: $height;
      width: $width;
    }
  }
}

.cm-html-preview {
  .v--modal-box {
    margin: 20px auto !important;
    transform-origin: 50% 0%;
  }
  .preview {
    &-container {
      border-radius: 24px;
      display: flex;
      justify-content: center;
      width: 100%;
      margin: 20px;
    }
    #email-iframe {
      height: 100%;
      overflow: auto;
    }
    &--mobile {
      @include previewTemplate(375px, 667px, 20px, 30px);
    }
    &--tablet {
      @include previewTemplate(480px, 668px, 40px, 30px); // 768 1024 / 1,39
    }
    &--desktop {
      @include previewTemplate(1024px, 668px, 30px);
    }
  }
}
</style>